/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Fire = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 12 13" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M3.38 13a3.16 3.16 0 0 1 .27-3.81 5.87 5.87 0 0 0 1-2.12A2.35 2.35 0 0 1 5 9a4.62 4.62 0 0 0 1.11-3.63A6 6 0 0 1 8.18 13c7.45-4 1.82-9.91.88-10.57a2.09 2.09 0 0 1-.27 2.35C7.68.81 4.93 0 4.93 0c.33 2-1.18 4.28-2.62 6a4.28 4.28 0 0 0-.56-2.16C1.64 5.27.44 6.48.12 8c-.45 2 .33 3.44 3.26 5z" />
      </g>
    </svg>
  </span>
);

Fire.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Fire.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Fire;
